<div>
    <!-- Page Header Card -->
    <div class="card border-0 shadow-sm rounded-4 mb-3 bg-body">
        <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div>
                    <h4 class="fw-bold text-body mb-1">LMS Coupon Codes</h4>
                    <p class="text-body-secondary small mb-0">
                        <span
                            class="badge bg-body-secondary text-body-secondary border px-2 py-1 font-monospace font-xs">Total
                            Records: {{ allTotal() }}</span>
                    </p>
                </div>

                <div class="d-flex gap-2">
                    <button type="button"
                        class="btn btn-sm btn-primary d-inline-flex align-items-center gap-2 px-3 py-2 shadow-sm fw-semibold"
                        data-bs-toggle="modal" data-bs-target="#generateLMSCouponCodeModal">
                        <i class="bi bi-plus-circle"></i>
                        <span>Generate Coupon</span>
                    </button>

                    <button type="button"
                        class="btn btn-sm btn-outline-success d-inline-flex align-items-center gap-2 px-3 py-2 fw-semibold"
                        data-bs-toggle="modal" data-bs-target="#downloadCSVModal">
                        <i class="bi bi-download"></i>
                        <span>Download CSV</span>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Table Container Card -->
    <div class="card border-0 shadow-sm rounded-4 overflow-hidden mb-4 bg-body">
        <div class="table-responsive m-0">
            <table class="table table-hover align-middle mb-0 text-nowrap">
                <thead
                    class="table-light text-body-secondary text-uppercase border-bottom font-monospace font-xs tracking-wider">
                    <tr>
                        <th class="ps-4 py-3" width="70">No</th>
                        <th class="py-3">Serial Number</th>
                        <th class="py-3">Coupon Code</th>
                        <th class="py-3">Course Catalog</th>
                        <th class="py-3" width="120">Points</th>
                        <th class="py-3" width="130">Status</th>
                        @if(lmsCouponCodesLst.length > 0) {    
                        <th class="pe-4 py-3 text-center" width="100">Action</th>
                        } 
                    </tr>
                </thead>

                <tbody class="border-top-0 small text-body">
                    @for (lms of lmsCouponCodesLst | paginate : { itemsPerPage: pageSize(), currentPage: page() + 1,
                    totalItems:
                    allTotal() }; track $index; let i = $index) {
                    <tr class="transition-base">
                        <td class="ps-4 text-body-secondary font-monospace fw-medium">{{ lms.srNo }}</td>
                        <td>
                            <span class="font-monospace fw-semibold text-body">{{ lms.serialNumber }}</span>
                        </td>
                        <td>
                            <code
                                class="px-2 py-1 bg-body-tertiary border rounded text-danger-emphasis font-monospace font-xs fw-medium">{{ lms.couponCode }}</code>
                        </td>
                        <td>
                            <span class="font-monospace fw-semibold text-body">{{ lms.courseCatalog }}</span>
                        </td>
                        <td>
                            <span
                                class="badge bg-info-subtle text-info-emphasis border border-info-subtle px-2.5 py-1.5 fw-semibold font-xs">
                                <i class="bi bi-coin me-1"></i>{{ lms.points }} pts
                            </span>
                        </td>
                        <td>
                            @if (lms.enabled) {
                            <span
                                class="badge bg-success-subtle text-success-emphasis border border-success-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 font-xs">
                                <span class="d-inline-block bg-success rounded-circle system-dot"
                                    style="width: 6px; height: 6px"></span>
                                Active
                            </span>
                            } @else {
                            <span
                                class="badge bg-danger-subtle text-danger-emphasis border border-danger-subtle px-2.5 py-1.5 rounded-pill d-inline-flex align-items-center gap-1.5 font-xs">
                                <span class="d-inline-block bg-danger rounded-circle system-dot"
                                    style="width: 6px; height: 6px"></span>
                                Disabled
                            </span>
                            }
                        </td>

                        <!-- Compact Centered Icon Loading Column -->
                        <td class="pe-4 text-center">
                            @if (isCouponCodeEnableDisableAccess() && lms.enabled) {
                            <button type="button"
                                class="btn btn-sm btn-icon btn-outline-danger shadow-sm transition-base d-inline-flex align-items-center justify-content-center"
                                (click)="enableLMSCouponCode(lms.serialNumber, lms.enabled, i)"
                                [disabled]="isEnableBtnLoading[i]()" title="Disable Coupon">
                                @if (isEnableBtnLoading[i]()) {
                                <span class="spinner-border micro-spinner m-0" role="status" aria-hidden="true"></span>
                                } @else {
                                <i class="bi bi-ban font-xs"></i>
                                }
                            </button>
                            } @else {
                            <span class="text-body-secondary small">-</span>
                            }
                        </td>
                    </tr>
                    } @empty {
                    <tr>
                        <td colspan="6" class="text-center py-5 bg-body-tertiary">
                            <div class="py-4 max-w-sm mx-auto" style="max-width: 360px">
                                <div class="d-inline-flex align-items-center justify-content-center bg-body rounded-circle mb-3 border"
                                    style="width: 64px; height: 64px">
                                    <i class="bi bi-ticket-perforated fs-3 text-body-secondary opacity-75"></i>
                                </div>
                                <h6 class="fw-semibold text-body mb-1">No Coupon Codes Found</h6>
                                <p class="text-body-secondary font-xs mb-0 px-3">
                                    We couldn't track any voucher or coupon files assigned to this index ledger.
                                </p>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    <!-- Pagination Layout Controls Anchor -->
    <div class="d-flex justify-content-center mt-3">
        <pagination-controls [maxSize]="10" previousLabel="&laquo;" nextLabel="&raquo;" [responsive]="true"
            class="dashboard-pagination" (pageChange)="handlePageChange($event)">
        </pagination-controls>
    </div>
</div>

<!-- Floating Mini Card Indicator -->
@if (loading()) {
<div class="position-fixed bottom-0 end-0 m-2 z-3 p-3 bg-body card border-info border-opacity-25 shadow-sm d-flex flex-row align-items-center gap-2"
    style="backdrop-filter: blur(4px)">
    <!-- Mini Spinner -->
    <div class="spinner-border text-info" style="width: 1rem; height: 1rem; border-width: 2px" role="status">
        <span class="visually-hidden">Loading...</span>
    </div>

    <!-- Text Badge Layout (Uses your global micro utilities) -->
    <div class="font-monospace text-info fw-bold tracking-widest text-uppercase pe-1 font-xs">Loading...</div>
</div>
}

<div class="modal fade" id="generateLMSCouponCodeModal" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-4 bg-body">
            <!-- Modal Header -->
            <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 class="modal-title fw-bold text-gradient-primary d-flex align-items-center">
                    <i class="bi bi-ticket-perforated me-2 fs-4"></i>
                    <span>Generate LMS Coupon Batch</span>
                </h5>
                <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
                    [disabled]="isgenerateLoading()"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body p-4 bg-body text-body">
                <!-- Section Subtitle -->
                <!-- <p class="text-body-secondary small mb-4">
                    Specify the volume configuration and credit parameters to distribute a fresh batch of sequential
                    system voucher tokens.
                </p> -->

                <form>
                    <!-- Coupon Count Input -->
                    <div class="form-floating mb-3">
                        <input type="number"
                            class="form-control bg-body text-body border-secondary-subtle shadow-sm focus-ring"
                            style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" id="couponCountInput"
                            min="1" placeholder="Enter quantity" [(ngModel)]="couponCount" name="couponCount"
                            [disabled]="isgenerateLoading()" />
                        <label for="couponCountInput" class="text-body-secondary fw-medium">Number of Coupon
                            Codes</label>
                    </div>

                    <!-- Points Input -->
                    <div class="form-floating mb-4">
                        <input type="number"
                            class="form-control bg-body text-body border-secondary-subtle shadow-sm focus-ring"
                            style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" id="couponPointsInput"
                            min="1" placeholder="Enter points" [(ngModel)]="couponPoints" name="couponPoints"
                            [disabled]="isgenerateLoading()" />
                        <label for="couponPointsInput" class="text-body-secondary fw-medium">Points Weight Per
                            Coupon</label>
                    </div>

                    <!-- Catalog Select (Dark-Mode Compliant Floating Label) -->
                    <div class="form-floating mb-2">
                        <select class="form-select bg-body text-body border-secondary-subtle shadow-sm focus-ring"
                            style="--bs-focus-ring-color: rgba(var(--bs-primary-rgb), 0.25)" id="catalogSelectInput"
                            [(ngModel)]="selectedCatalogName" name="selectedCatalogName"
                            [disabled]="isgenerateLoading()">

                            <!-- Disabled Default Prompt Option -->
                            <option value="" disabled selected hidden class="text-body-secondary">Choose from active
                                groups...</option>

                            <!-- Loop through your catalog name list signal -->
                            @for (catalogName of courseCatalogNameList(); track catalogName) {
                            <option [value]="catalogName" class="bg-body text-body">{{ catalogName }}</option>
                            } @empty {
                            <option value="" disabled class="text-body-secondary">⚠️ No active catalogs found...
                            </option>
                            }
                        </select>
                        <label for="catalogSelectInput" class="text-body-secondary fw-semibold">
                            Catalog Name <span class="text-danger">*</span>
                        </label>
                    </div>
                </form>
            </div>


            <!-- Modal Footer -->
            <div class="modal-footer border-top-0 pt-2 pb-4 px-4">
                <button type="button" class="btn btn-sm btn-light px-3 fw-medium text-body-secondary"
                    data-bs-dismiss="modal" [disabled]="isgenerateLoading()">
                    Cancel
                </button>

                <button type="button"
                    class="btn btn-sm btn-primary px-4 fw-bold shadow-sm d-inline-flex align-items-center gap-1.5 micro-action-btn"
                    (click)="generateCouponCode()" [disabled]="!couponCount || !couponPoints || isgenerateLoading()">
                    @if (isgenerateLoading()) {
                    <span class="spinner-border micro-spinner" role="status" aria-hidden="true"></span>
                    <span>Generating...</span>
                    } @else {
                    <i class="bi bi-plus-circle font-xs"></i>
                    <span>Generate Cards</span>
                    }
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="downloadCSVModal" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg rounded-4 bg-body">
            <!-- Modal Header -->
            <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
                <h5 class="modal-title fw-bold text-gradient-primary d-flex align-items-center">
                    <i class="bi bi-file-earmark-arrow-down me-2 fs-4"></i>
                    <span>Export Sequence Ledger</span>
                </h5>
                <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"
                    [disabled]="downloading()"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body py-3 px-4">
                <p class="text-body-secondary font-xs mb-3">
                    Provide a naming label and define your numeric voucher threshold index parameters to isolate
                    spreadsheet
                    generation queries.
                </p>

                <!-- File Name Input -->
                <div class="form-floating mb-3">
                    <input type="text" class="form-control border-2 shadow-none" id="fileNameInput"
                        placeholder="Enter file name" [(ngModel)]="downloadFileName" [disabled]="downloading()" />
                    <label for="fileNameInput" class="text-body-secondary fw-medium">File Name Target</label>
                </div>

                <!-- Serial Index Row Spacing -->
                <div class="row g-2 mb-1">
                    <div class="col-6">
                        <div class="form-floating">
                            <input type="text"
                                class="form-control border-2 shadow-none font-monospace font-xs fw-semibold"
                                id="startSerialInput" placeholder="Enter start serial number"
                                [(ngModel)]="startSerialNumber" [disabled]="downloading()" />
                            <label for="startSerialInput" class="text-body-secondary fw-medium">Start Serial No.</label>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-floating">
                            <input type="text"
                                class="form-control border-2 shadow-none font-monospace font-xs fw-semibold"
                                id="endSerialInput" placeholder="Enter end serial number" [(ngModel)]="endSerialNumber"
                                [disabled]="downloading()" />
                            <label for="endSerialInput" class="text-body-secondary fw-medium">End Serial No.</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer border-top-0 pt-2 pb-4 px-4">
                <button type="button" class="btn btn-sm btn-light px-3 fw-medium text-body-secondary"
                    data-bs-dismiss="modal" [disabled]="downloading()">
                    Cancel
                </button>

                <button type="button"
                    class="btn btn-sm btn-success text-white px-4 fw-bold shadow-sm d-inline-flex align-items-center gap-1.5 micro-action-btn"
                    (click)="downloadFile()" [disabled]="!downloadFileName || downloading()">
                    @if (downloading()) {
                    <span class="spinner-border micro-spinner text-white" role="status" aria-hidden="true"></span>
                    <span>Exporting...</span>
                    } @else {
                    <i class="bi bi-download font-xs"></i>
                    <span>Export CSV</span>
                    }
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Floating Action Error Notification Toast -->
@if (errorToast()) {
<div class="position-fixed bottom-0 end-0 p-3 z-3">
    <div class="toast show align-items-center bg-danger-subtle border border-danger border-opacity-25 shadow-lg p-1"
        role="alert" aria-live="assertive" aria-atomic="true" style="min-width: 320px; border-radius: 12px">
        <div class="d-flex align-items-center justify-content-between">
            <!-- Toast Body Message -->
            <div class="toast-body d-flex align-items-center py-2 gap-2">
                <i class="bi bi-exclamation-circle-fill text-danger fs-5 flex-shrink-0"></i>
                <div>
                    <span class="d-block fw-bold font-xs text-uppercase text-danger-emphasis tracking-wider">System
                        Error</span>
                    <span class="font-xs fw-semibold text-body-secondary">{{ errorToast() }}</span>
                </div>
            </div>

            <!-- Native Close Trigger -->
            <button type="button" class="btn-close me-2 shadow-none" (click)="errorToast.set(null)"
                aria-label="Close"></button>
        </div>
    </div>
</div>
}